import {
    FolderTree,
    Filter,
    Package,
    Store,
    TrendingUp,
    Users,
    Wallet,
    Warehouse,
} from 'lucide-react';

/**
 * The report sections, in the order they appear in the sub-navigation.
 *
 * `platformOnly` mirrors the backend: those endpoints raise 403 for the
 * `irancharsouq_admin` scope, so the tabs must not be offered to them.
 */
export const REPORT_SECTIONS = [
    {
        key: 'sales',
        label: 'فروش',
        path: 'sales',
        icon: TrendingUp,
        platformOnly: false,
        description: 'درآمد، سفارش و میانگین سبد خرید در بازه انتخابی',
    },
    {
        key: 'products',
        label: 'پرفروش‌ترین کالاها',
        path: 'products',
        icon: Package,
        platformOnly: false,
        description: 'کالاهای برتر بر پایه درآمد یا تعداد فروش',
    },
    {
        key: 'categories',
        label: 'دسته‌بندی‌ها',
        path: 'categories',
        icon: FolderTree,
        platformOnly: false,
        description: 'عملکرد دسته‌ها به‌همراه سهم آن‌ها از درآمد',
    },
    {
        key: 'inventory',
        label: 'موجودی و انبار',
        path: 'inventory',
        icon: Warehouse,
        platformOnly: false,
        description: 'ارزش موجودی، کالاهای رو به اتمام و سرعت فروش',
    },
    {
        key: 'orders',
        label: 'قیف سفارش‌ها',
        path: 'orders',
        icon: Filter,
        platformOnly: false,
        description: 'وضعیت سفارش‌ها از ثبت تا تحویل و نرخ تحقق',
    },
    {
        key: 'finance',
        label: 'مالی',
        path: 'finance',
        icon: Wallet,
        platformOnly: true,
        description: 'تراکنش‌ها، روش‌های پرداخت و تسویه‌ها',
    },
    {
        key: 'customers',
        label: 'مشتریان',
        path: 'customers',
        icon: Users,
        platformOnly: true,
        description: 'مشتریان وفادار، نرخ خرید دوباره و کوهورت‌ها',
    },
    {
        key: 'vendors',
        label: 'فروشندگان',
        path: 'vendors',
        icon: Store,
        platformOnly: true,
        description: 'رتبه‌بندی فروشندگان و سهم هر یک از درآمد',
    },
];

/** Sections the given role is allowed to open. */
export function sectionsForRole(activeRole) {
    if (activeRole === 'super_admin') return REPORT_SECTIONS;
    return REPORT_SECTIONS.filter((section) => !section.platformOnly);
}

/** Sections that carry a granularity switch (timeseries and month views). */
export const GRANULARITY_SECTIONS = new Set(['sales']);
